(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallStatusSearch', PhoneCallStatusSearch);

    PhoneCallStatusSearch.$inject = ['$resource'];

    function PhoneCallStatusSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
